// ═══════════════════════════════════════════════════════════════════
//  modules/erp/textures.js
//  MC_VERSION · TEX_LOCAL · TEX_CDN · itemTextureCandidates · getItemEmoji
// ═══════════════════════════════════════════════════════════════════

import { API_BASE } from "../../socle/api";

// ─── ERP JOUEURS ───

// ── Config textures ──────────────────────────────────────────────────
// MC_VERSION ne sert que de secours (CDN) si une texture n'est pas en
// local. Comme le script d'export remplit mc-textures en local, sa
// valeur exacte n'a quasiment pas d'importance.
export const MC_VERSION = "1.21.4";

export const TEX_LOCAL = `${API_BASE}/mc-textures`;

export const TEX_CDN = `https://assets.mcasset.cloud/${MC_VERSION}/assets/minecraft/textures`;

// Liste des URLs candidates pour un item, dans l'ordre de priorité.
export function itemTextureCandidates(item) {
  const id = item.id.replace("minecraft:", "");
  const urls = [];

  // ItemsAdder custom — actif dès que le backend fournit item.iaId
  if (item.iaId) {
    const ia = item.iaId.replace("minecraft:", "").replace(":", "/");
    urls.push(`${TEX_LOCAL}/itemsadder/${ia}.png`);
  }

  // Vanilla auto-hébergé (item puis block)
  urls.push(`${TEX_LOCAL}/item/${id}.png`);
  urls.push(`${TEX_LOCAL}/block/${id}.png`);

  // Vanilla CDN en secours
  urls.push(`${TEX_CDN}/item/${id}.png`);
  urls.push(`${TEX_CDN}/block/${id}.png`);

  return urls;
}

export function getItemEmoji(id) {
  const map = {
    "minecraft:netherite_sword": "⚔️", "minecraft:diamond_sword": "⚔️", "minecraft:iron_sword": "⚔️",
    "minecraft:stone_sword": "⚔️", "minecraft:wooden_sword": "⚔️", "minecraft:golden_sword": "⚔️",
    "minecraft:netherite_pickaxe": "⛏️", "minecraft:diamond_pickaxe": "⛏️", "minecraft:iron_pickaxe": "⛏️",
    "minecraft:stone_pickaxe": "⛏️", "minecraft:wooden_pickaxe": "⛏️",
    "minecraft:netherite_axe": "🪓", "minecraft:diamond_axe": "🪓", "minecraft:iron_axe": "🪓",
    "minecraft:netherite_shovel": "🔧", "minecraft:diamond_shovel": "🔧",
    "minecraft:netherite_hoe": "🌾", "minecraft:diamond_hoe": "🌾",
    "minecraft:netherite_helmet": "🪖", "minecraft:diamond_helmet": "🪖", "minecraft:iron_helmet": "🪖",
    "minecraft:netherite_chestplate": "🛡️", "minecraft:diamond_chestplate": "🛡️", "minecraft:iron_chestplate": "🛡️",
    "minecraft:netherite_leggings": "👖", "minecraft:diamond_leggings": "👖", "minecraft:iron_leggings": "👖",
    "minecraft:netherite_boots": "👢", "minecraft:diamond_boots": "👢", "minecraft:iron_boots": "👢",
    "minecraft:bow": "🏹", "minecraft:crossbow": "🏹", "minecraft:arrow": "➡️", "minecraft:shield": "🛡️",
    "minecraft:apple": "🍎", "minecraft:golden_apple": "🍎", "minecraft:enchanted_golden_apple": "🍎",
    "minecraft:bread": "🍞", "minecraft:cooked_beef": "🥩", "minecraft:cooked_chicken": "🍗",
    "minecraft:diamond": "💎", "minecraft:emerald": "💚", "minecraft:gold_ingot": "🟡",
    "minecraft:iron_ingot": "⚙️", "minecraft:coal": "⬛", "minecraft:netherite_ingot": "🔩",
    "minecraft:torch": "🔦", "minecraft:ender_pearl": "🟣", "minecraft:blaze_rod": "🔥",
    "minecraft:book": "📖", "minecraft:enchanted_book": "📖", "minecraft:written_book": "📖",
    "minecraft:totem_of_undying": "🗿", "minecraft:elytra": "🪂", "minecraft:trident": "🔱",
    "minecraft:fishing_rod": "🎣", "minecraft:flint_and_steel": "🔥", "minecraft:compass": "🧭",
    "minecraft:map": "🗺️", "minecraft:clock": "🕐", "minecraft:spyglass": "🔭",
    "minecraft:grass_block": "🟩", "minecraft:dirt": "🟫", "minecraft:stone": "🪨",
    "minecraft:cobblestone": "🪨", "minecraft:oak_log": "🪵", "minecraft:oak_planks": "🟫",
    "minecraft:glass": "🔷", "minecraft:sand": "🟡", "minecraft:gravel": "⬜",
    "minecraft:obsidian": "⬛", "minecraft:chest": "📦", "minecraft:crafting_table": "🔨",
    "minecraft:furnace": "🔥", "minecraft:tnt": "💣", "minecraft:bucket": "🪣",
    "minecraft:water_bucket": "🪣", "minecraft:lava_bucket": "🪣",
  };
  return map[id] || "📦";
}
